import I18n from '@front/volcanion/utils/translation'

class Callbacks {

  static onSubmitHandler(upload, file, navigate, openNotification) {
    return async function onSubmit() {
      if (!file?.name) {
        openNotification(I18n.t('toast.file.error.not_found'), { variant: 'error' })
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      try {
        const result = await upload(formData)
        navigate(`/list/${result?.list_id}`)
      } catch (err) {
        openNotification(_.get(err, 'message', I18n.t('toast.file.error.imported')), { variant: 'error' })
      }
    }
  }

  static importFileHandler(setFile, openNotification) {
    return function importFile(e) {
      const new_file = e?.target?.files[0]
      if (!!new_file?.name) {
        setFile(new_file)
        openNotification(I18n.t('toast.file.success.imported', { name: new_file?.name }), { variant: 'success' })
      } else
        openNotification(I18n.t('toast.file.error.imported'), { variant: 'error' })
    }
  }
}

export default Callbacks
